function HoverLetter({letter}) {
  return (
    <span className="text-customwhite font-extrabold hover:text-gray-500 transition-color ease-in-out duration-300">
        {letter}
  </span>
  );
}

export default HoverLetter;
